import React, { useEffect, useMemo } from 'react';

import { formatCurrency, parseCurrency } from '@brazilian-utils/brazilian-utils';
import { Flex, Text, HStack } from '@chakra-ui/react';
import { isNaN } from 'lodash';
import { Controller, UseFormReturn } from 'react-hook-form';

import { Radio, Input } from 'components';
import { FrequencyTypes } from 'enums/types';

import FrequencyForm from './Frequency';

export default function InfoForm({
  register, control, watch, setValue,
}: UseFormReturn) {
  const frequency = watch('frequency');
  const formDay = watch('day') ?? [];
  const days = useMemo(() => {
    if (Array.isArray(formDay)) {
      return formDay;
    }
    return Object.values(formDay);
  }, [frequency, formDay]);

  const numberOfDays = {
    [FrequencyTypes.Weekly]: days.filter((day) => !!day).length * 4.3,
    [FrequencyTypes.Monthly]: 1,
    [FrequencyTypes.Single]: 1,
    [FrequencyTypes.Biweekly]: 2,
  }[frequency];

  const daily = watch('info.dailyKm');
  useEffect(() => {
    if (frequency && daily) {
      const km = isNaN(daily) ? 0 : daily;

      setValue('info.monthlyKm', Number(km * numberOfDays)?.toFixed(2));
    }
  }, [frequency, daily, numberOfDays]);

  return (
    <Flex
      flexDir="column"
      mt={7}>
      <Flex
        flexDir="column">
        <Text
          color="gray.600"
          variant="smallSemiBold"
          mb={3}>
          Frequência:
        </Text>
        <Controller
          control={control}
          name="frequency"
          render={({ field }) => (
            <Radio
              mb={7}
              {...field}
              options={[
                { label: 'Única', value: FrequencyTypes.Single },
                { label: 'Semanal', value: FrequencyTypes.Weekly },
                { label: 'Quinzenal', value: FrequencyTypes.Biweekly },
                { label: 'Mensal', value: FrequencyTypes.Monthly }]}
            />
          )}
        />
      </Flex>
      <FrequencyForm
        frequency={watch('frequency')}
        register={register}
        setValue={setValue}
      />
      <HStack
        spacing={4}
        my={7}>
        <Input
          label="Valor da rota (opcional)"
          LeftElement={() => <Text fontSize="sm">R$</Text>}
          {...register('info.routeCents')}
          placeholder="1000,00"
          onChange={({ target: { value } }) => setValue('info.routeCents', formatCurrency(parseCurrency(value)))}
        />
        <Input
          label="Valor do KM excedente (opcional)"
          LeftElement={() => <Text fontSize="sm">R$</Text>}
          {...register('info.excessKmCents')}
          placeholder="10,00"
          onChange={({ target: { value } }) => setValue('info.excessKmCents', formatCurrency(parseCurrency(value)))}
        />
      </HStack>
      <HStack
        spacing={4}
        mb={7}>
        <Input
          label="Km Diário (previsão)"
          {...register('info.dailyKm')}
          RightElement={() => <Text fontSize="sm">Km</Text>}
          placeholder="000"
        />
        <Input
          label="Km Mensal (previsão)"
          {...register('info.monthlyKm')}
          RightElement={() => <Text fontSize="sm">Km</Text>}
          placeholder="000.000"
        />
      </HStack>
      <HStack
        spacing={4}
        mb={7}>
        <Input
          label="Origem"
          {...register('info.source')}
          placeholder="Origem"
        />
        <Input
          label="Destino"
          {...register('info.destination')}
          placeholder="Destino"
        />
      </HStack>
    </Flex>
  );
}
